import { createFileRoute } from "@tanstack/react-router";
import CropZoneEditor from "@/components/field/setup/CropZoneEditor";

export const Route = createFileRoute(
    "/dashboard/fields/$fieldId/setup/crop-zones/$cropZoneId",
)({
    component: CropZoneEditPane,
});

function CropZoneEditPane() {
    const { cropZoneId } = Route.useParams();
    return <CropZoneEditor cropZoneId={cropZoneId} />;
}
